import { defineStyle } from '@chakra-ui/styled-system';

const InputTheme = defineStyle({
  baseStyle: {
    field: {
      _disabled: {
        _hover: {
          borderColor: 'border.disabled',
        },
        _placeholder: {
          color: 'text.disabled',
        },
        color: 'text.disabled',
        background: 'background.disabled',
        cursor: 'not-allowed',
      },
      _focus: {
        boxShadow: 'formFocus',
      },
      _focusVisible: {
        boxShadow: 'formFocus',
      },
      _hover: {
        borderColor: 'border.hover',
      },
      _invalid: {
        _hover: {
          borderColor: 'border.error',
        },
        borderColor: 'border.error',
        color: 'input.text.error',
      },
      _placeholder: {
        color: 'input.text.placeholder',
      },
      _readOnly: {
        _hover: {
          borderColor: 'border.regular',
        },
        background: 'background.disabled',
      },
      appearance: 'none',
      background: 'background.primary',
      border: '1px solid',
      borderColor: 'border.regular',
      borderRadius: '4',
      boxShadow: 'inner',
      outline: 0,
      transition: '200ms',
      width: '100%',
    },
    icon: {
      color: 'icon.tertiary',
      _groupHover: {
        color: 'icon.primary',
        _disabled: {
          color: 'icon.on-disabled',
        },
      },
      _disabled: {
        color: 'icon.on-disabled',
      },
    },
    leftIconWrapper: {
      pointerEvents: 'none',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    rightIconWrapper: {
      pointerEvents: 'none',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    inputContainer: {
      position: 'relative',
    },
  },
  sizes: {
    lg: {
      field: {
        fontSize: '3',
        height: '48',
      },
    },
    md: {
      field: {
        fontSize: '2',
        height: '40',
      },
    },
  },
});

export default InputTheme;
